import { DoohInventoryFilters } from '@/components/doohInventory/DoohInventoryFilters';
import { DoohInventoryHeader } from '@/components/doohInventory/DoohInventoryHeader';
import { DoohInventoryList } from '@/components/doohInventory/DoohInventoryList';
import DoohInventoryMap from '@/components/doohInventory/DoohInventoryMap/DoohInventoryMap';
import { DoohInventoryMapVolumetry } from '@/components/doohInventory/DoohInventoryMapVolumetry';
import { DoohInventoryVolumetry } from '@/components/doohInventory/DoohInventoryVolumetry';
import { DoohInventoryProvider } from '@/context/DoohInventoryContext';
import { Theme } from '@/providers';

import './index.scss';

export default function DoohInventoryPage() {
  return (
    <Theme theme="dark">
      <DoohInventoryProvider>
        <div className="doohInventory__container">
          <header className="doohInventory__containerHeader">
            <DoohInventoryHeader />
          </header>
          <section className="doohInventory__containerLeft">
            <DoohInventoryVolumetry />
            <DoohInventoryFilters />
            <DoohInventoryList />
          </section>
          <section className="doohInventory__containerRight">
            <div className="mapContainer" id="map">
              <DoohInventoryMap />
            </div>
            <div className="doohInventory__mapVolumetry">
              <DoohInventoryMapVolumetry />
            </div>
          </section>
        </div>
      </DoohInventoryProvider>
    </Theme>
  );
}
